import { render, staticRenderFns } from "./Erp6PurchaseOrder.vue?vue&type=template&id=2b83d28d&scoped=true&"
import script from "./Erp6PurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./Erp6PurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./Erp6PurchaseOrder.vue?vue&type=style&index=0&id=2b83d28d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83d28d",
  null
  
)

export default component.exports